module.exports = __webpack_public_path__ + "static/media/grid2.0ad29ef7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/grid2.jpg
// module id = 880
// module chunks = 0